<script lang="ts">
  function scroll_top() {
    window.scrollTo(0, 0);
  }
  function scroll_bottom() {
    window.scrollTo(0, document.body.scrollHeight);
  }
</script>

<div
  style="position: fixed; bottom: 50px; right: 50px; z-index:99; opacity: 0; display: none;"
  id="float-scroll"
>
  <div class="position-relative" on:click={scroll_top}>
    <img
      src="/images/common/icon_up.png"
      class="position-absolute top-50 start-50 translate-middle"
      alt="맨위로"
    />
  </div>
  <div id="link2" on:click={scroll_bottom}>
    <img
      src="/images/common/icon_down.png"
      class="position-absolute top-50 start-50 translate-middle"
      alt="맨아래로"
    />
  </div>
  <div id="link3">
    <a href="/contact">
      <img src="/images/common/icon_phone.png" alt="전화" />
    </a>
  </div>
</div>

<style lang="scss">
  #float-scroll {
    transition: opacity 0.25s;
    > div {
      width: 50px;
      height: 50px;
      background-color: rgb(195 195 195 / 60%);
      border-radius: 50%;
      margin: 10px auto;
      cursor: pointer;
    }
  }
</style>
